module.exports = __webpack_public_path__ + "static/logo-rishit-kedia-06e902967d38b02dd8d14ed3b85e5e2d.svg";